import { IContentBlockWithIcon } from "contentful-types"
import React, { FC } from "react"
import styled from "styled-components"
import { DynamicContentComponentProps } from "./DynamicContentComponentProps"

const DynamicIcon = styled.img`
  margin-bottom: 8px;
`

const DynamicBodySmall = styled.p`
  display: block;
  font-size: 14px;
  line-height: 150%;
  color: rgba(0, 0, 0, 0.8);
  font-family: "Gotham A", "Gotham B", sans-serif;
  font-weight: normal;
  margin-top: 0px;
  margin-bottom: 24px;
`

export const ContentBlockWithIcon: FC<DynamicContentComponentProps<IContentBlockWithIcon>> = ({ content }) => {
  const {
    fields: { body, icon }
  } = content
  return (
    <>
      {icon.fields && <DynamicIcon src={icon.fields.file.url} height={60} width={60} />}
      <DynamicBodySmall>{body}</DynamicBodySmall>
    </>
  )
}
